module.exports = __webpack_public_path__ + "494cd07c/img/arrow-share-icon.00a12c29.svg";